<div class="card">
  <div class="card-header">Não autorizado</div>
  <div class="card-body d-flex justify-content-center">
    <img class="my-7" src="assets/bt/img/unauthorized.svg">
  </div>
</div>
